import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_2 = { class: "kn-overflow" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = {
  key: 1,
  class: "p-grid p-m-2",
  "data-test": "card-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataPreparationMonitoringDialog = _resolveComponent("DataPreparationMonitoringDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnDatasetList = _resolveComponent("KnDatasetList")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Chip = _resolveComponent("Chip")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceCard = _resolveComponent("WorkspaceCard")
  const _component_DetailSidebar = _resolveComponent("DetailSidebar")
  const _component_EditPreparedDatasetDialog = _resolveComponent("EditPreparedDatasetDialog")
  const _component_Menu = _resolveComponent("Menu")
  const _component_WorkspaceDataCloneDialog = _resolveComponent("WorkspaceDataCloneDialog")
  const _component_WorkspaceDataPreviewDialog = _resolveComponent("WorkspaceDataPreviewDialog")
  const _component_WorkspaceWarningDialog = _resolveComponent("WorkspaceWarningDialog")
  const _component_DataPreparationAvroHandlingDialog = _resolveComponent("DataPreparationAvroHandlingDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DataPreparationMonitoringDialog, {
      visibility: _ctx.showMonitoring,
      "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMonitoring = $event)),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMonitoring = false)),
      onSave: _ctx.updateDatasetAndSave,
      dataset: _ctx.selectedDataset
    }, null, 8, ["visibility", "onSave", "dataset"]),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workspace.advancedData.title')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-list",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-th-large",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_KnFabButton, {
          icon: "fas fa-plus",
          "data-test": "new-folder-button",
          onClick: _ctx.showDataSetCatalog
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar p-ml-2",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_KnDatasetList, {
      visibility: _ctx.showDatasetList,
      items: _ctx.availableDatasets,
      onSelected: _ctx.newDataPrep,
      onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSave(_ctx.selectedDsForDataPrep))),
      onCancel: _ctx.hideDataSetCatalog
    }, null, 8, ["visibility", "items", "onSelected", "onCancel"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InputText, {
        class: "kn-material-input p-m-2",
        style: _ctx.mainDescriptor.style.filterInput,
        modelValue: _ctx.searchWord,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchWord = $event)),
        type: "text",
        placeholder: _ctx.$t('common.search'),
        onInput: _ctx.searchItems,
        "data-test": "search-input"
      }, null, 8, ["style", "modelValue", "placeholder", "onInput"])
    ]),
    _createVNode("div", _hoisted_2, [
      (!_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table p-mx-2",
            value: _ctx.preparedDatasets,
            loading: _ctx.loading,
            dataKey: "objId",
            responsiveLayout: "stack",
            breakpoint: "600px",
            "data-test": "datasets-table"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "label",
                header: _ctx.$t('importExport.catalogFunction.column.label'),
                class: "kn-truncated",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "name",
                header: _ctx.$t('importExport.gallery.column.name'),
                class: "kn-truncated",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "tags",
                header: _ctx.$t('importExport.gallery.column.tags'),
                sortable: true
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.tags.length > 0)
                    ? (_openBlock(), _createBlock("span", _hoisted_3, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.tags, (tag, index) => {
                          return (_openBlock(), _createBlock(_component_Chip, { key: index }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                style: _ctx.mainDescriptor.style.iconColumn
              }, {
                header: _withCtx(() => [
                  _hoisted_4
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "fas fa-ellipsis-v",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.showMenu($event, slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"]),
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "fas fa-info-circle",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.showSidebar(slotProps.data)), ["stop"]),
                    "data-test": 'info-button-' + slotProps.data.name
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('workspace.myModels.showInfo'),
                      void 0,
                      { left: true }
                    ]
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-eye",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.previewDataset(slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.preparedDatasets.length === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "kn-flex p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.mainDescriptor.style.message
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.preparedDatasets, (dataset, index) => {
                  return (_openBlock(), _createBlock(_component_WorkspaceCard, {
                    key: index,
                    viewType: 'dataset',
                    document: dataset,
                    onPreviewDataset: _ctx.previewDataset,
                    onEditDataset: _ctx.editDataset,
                    onExportToXlsx: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportDataset($event, 'xls'))),
                    onExportToCsv: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportDataset($event, 'csv'))),
                    onShareDataset: _ctx.shareDataset,
                    onCloneDataset: _ctx.cloneDataset,
                    onDeleteDataset: _ctx.deleteDatasetConfirm,
                    onOpenDataPreparation: _ctx.openDataPreparation,
                    onOpenSidebar: _ctx.showSidebar,
                    onMonitoring: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring))
                  }, null, 8, ["document", "onPreviewDataset", "onEditDataset", "onShareDataset", "onCloneDataset", "onDeleteDataset", "onOpenDataPreparation", "onOpenSidebar"]))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DetailSidebar, {
      visible: _ctx.showDetailSidebar,
      viewType: 'dataset',
      document: _ctx.selectedDataset,
      onPreviewDataset: _ctx.previewDataset,
      onEditDataset: _ctx.editDataset,
      onExportToXlsx: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportDataset($event, 'xls'))),
      onExportToCsv: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exportDataset($event, 'csv'))),
      onShareDataset: _ctx.shareDataset,
      onCloneDataset: _ctx.cloneDataset,
      onDeleteDataset: _ctx.deleteDatasetConfirm,
      onOpenDataPreparation: _ctx.openDataPreparation,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDetailSidebar = false)),
      onMonitoring: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring)),
      "data-test": "detail-sidebar"
    }, null, 8, ["visible", "document", "onPreviewDataset", "onEditDataset", "onShareDataset", "onCloneDataset", "onDeleteDataset", "onOpenDataPreparation"]),
    _createVNode(_component_EditPreparedDatasetDialog, {
      dataset: _ctx.selectedDataset,
      visible: _ctx.showEditPreparedDatasetDialog,
      onSave: _ctx.updatePreparedDataset,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEditPreparedDatasetDialog = false))
    }, null, 8, ["dataset", "visible", "onSave"]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"]),
    _createVNode(_component_Menu, {
      id: "creationMenu",
      ref: "creationMenu",
      model: _ctx.creationMenuButtons
    }, null, 8, ["model"]),
    _createVNode(_component_WorkspaceDataCloneDialog, {
      visible: _ctx.cloneDialogVisible,
      propDataset: _ctx.selectedDataset,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cloneDialogVisible = false)),
      onClone: _ctx.handleDatasetClone
    }, null, 8, ["visible", "propDataset", "onClone"]),
    _createVNode(_component_WorkspaceDataPreviewDialog, {
      visible: _ctx.previewDialogVisible,
      propDataset: _ctx.selectedDataset,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.previewDialogVisible = false))
    }, null, 8, ["visible", "propDataset"]),
    _createVNode(_component_WorkspaceWarningDialog, {
      visible: _ctx.warningDialogVisbile,
      title: _ctx.$t('workspace.advancedData.title'),
      warningMessage: _ctx.warningMessage,
      onClose: _ctx.closeWarningDialog
    }, null, 8, ["visible", "title", "warningMessage", "onClose"]),
    _createVNode(_component_DataPreparationAvroHandlingDialog, {
      visible: _ctx.dataPrepAvroHandlingDialogVisbile,
      title: _ctx.$t('workspace.myData.isPreparing'),
      infoMessage: _ctx.dataPrepAvroHandlingMessage,
      onClose: _ctx.proceedToDataPrep,
      events: _ctx.events
    }, null, 8, ["visible", "title", "infoMessage", "onClose", "events"])
  ], 64))
}